import { render, staticRenderFns } from "./IssueHeader.vue?vue&type=template&id=b9b8cf4a&scoped=true&"
import script from "./IssueHeader.vue?vue&type=script&lang=js&"
export * from "./IssueHeader.vue?vue&type=script&lang=js&"
import style0 from "./IssueHeader.vue?vue&type=style&index=0&id=b9b8cf4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b8cf4a",
  null
  
)

export default component.exports